__turbopack_context__.v({
  "assetsContainer": "StaticProjectNav-module__iuvXCa__assetsContainer",
  "assetsLoading": "StaticProjectNav-module__iuvXCa__assetsLoading",
  "container": "StaticProjectNav-module__iuvXCa__container",
  "driveFloatingToast": "StaticProjectNav-module__iuvXCa__driveFloatingToast",
  "projectHeader": "StaticProjectNav-module__iuvXCa__projectHeader",
  "rightContents": "StaticProjectNav-module__iuvXCa__rightContents",
  "section": "StaticProjectNav-module__iuvXCa__section",
  "sectionTitle": "StaticProjectNav-module__iuvXCa__sectionTitle",
  "sharesList": "StaticProjectNav-module__iuvXCa__sharesList",
  "titleText": "StaticProjectNav-module__iuvXCa__titleText",
  "treeContainer": "StaticProjectNav-module__iuvXCa__treeContainer",
});
